import * as React from 'react'
// import * as DateFns from 'date-fns'
import styled from 'styled-components'
// import { useDispatch } from 'redux-react-hook'
import { Icon } from '../../atoms/icon'
import { Button, ButtonGroup } from '../../atoms/button'
import { Form } from 'react-final-form'
import TextAreaFieldItem from '../../molecules/text-field/textarea-field'
import HiddenFieldItem from '../../molecules/text-field/hidden-field'
// import { StatusIcon } from '../../molecules/status-icon'
import { Color, Size } from '../../../constants/app.constant'
// import history from '../../utils/history'
import useGetState from '../../../hooks/use-get-state'
// import { Inquiry } from '../../../interfaces/inquiry'
import { dispAge, calcAge } from '../report/utils'
import {
  composeValidators,
  required,
  // alphabeticAndNumeric,
} from '../../../utils/validator'
import { when } from '../../../utils/mixin'
import { postInquiryQuestion } from '../../../actions/inquiry.action'
import { useDispatch } from 'redux-react-hook'

// const { useState, useEffect } = React
const { useEffect } = React
export default () => {
  const dispatch = useDispatch()

  const {
    state: {
      auth,
      patient,
      inquiry: { inquiries },
    },
  } = useGetState()

  const onSubmit = async (formValues: any) => {
    console.log('contents')
    console.log(formValues)
    const payload = {
      ...formValues,
      jwtToken: auth.user.idToken.jwtToken,
    }
    console.log(payload)
    dispatch(postInquiryQuestion(payload))
  }

  // const [node, setNode] = useState()
  // const [localLogs, setLocalLogs] = useState([])
  //   let defaultWidth = 0
  //  const defaultHeight = 60
  //  const colors = [Color.STATUS_COLOR.STATUS_1, Color.STATUS_COLOR.STATUS_2, Color.STATUS_COLOR.STATUS_3, Color.STATUS_COLOR.STATUS_4]
  useEffect(
    () => {
      console.log(inquiries)
      // if (inquiries)
      // setLocalLogs(inquiries.sort((x: Inquiry, y: Inquiry) => new Date(y.updatedAt).getTime() - new Date(x.updatedAt).getTime()))
    },
    [inquiries]
  )
  return (
    <Wrapper>
      <PageContents>
      <PageTitle>
          <PageTitleName>新規お問い合わせ</PageTitleName>
        </PageTitle>
        <UserDetail>
          <Icon.User size={`${Size.XLARGE}px`} color={Color.DARK_GRAY} />
          <UserName>
            {patient.username}
            さん
          </UserName>
          <Age>{dispAge(calcAge(patient.birthdayYmd))}</Age>
          {/* 
          <ButtonGroup vertical css="width: 168px;margin: 30px auto;">
              <Button onClick={() => history.push(`/inquiry_form/`)}>新規お問い合わせ</Button>
          </ButtonGroup>
          */}
        </UserDetail>
        <FormWrapper>
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {}
              errors.question = composeValidators(
                required('質問を入力してください')
              )(values.question)
              return errors
            }}
            initialValues={{
              patientId: auth.user.idToken.payload['custom:userId'],
            }}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <HiddenFieldItem
                  name="patientId"
                  type="hidden"
                  value={auth.user.idToken.payload['custom:userId']}
                />
                <FieldSet>
                  <TextAreaFieldItem
                    name="question"
                    type="textarea"
                    label="質問"
                    placeholder="質問内容を入力してください"
                    vertical
                    required={true}
                  />
                </FieldSet>
                <ButtonGroup vertical css="width: 168px;margin: 30px auto;">
                  <Button primary>送信</Button>
                </ButtonGroup>
              </form>
            )}
          />
        </FormWrapper>
      </PageContents>
    </Wrapper>
  )
}

const Wrapper = styled.div``
const PageContents = styled.div``
const PageTitle = styled.div`
  margin: 8px;
  display: flex;
  align-items: center;
`

const PageTitleName = styled.div`
  font-size: ${Size.LARGE}px;
  margin-left: 8px;
  margin-right: 8px;
`
const UserDetail = styled.div`
  margin: 8px;
  display: flex;
  align-items: center;
`

const UserName = styled.div`
  font-size: ${Size.BASE}px;
  margin-left: 8px;
  margin-right: 8px;
`
const Age = styled.div`
  font-size: ${Size.BASE}px;
`

const FormWrapper = styled.div`
  padding: 50px 30px 0;
`
const FieldSet = styled.div<{
  vertical?: boolean
}>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  padding: 0 30px;
  div {
    width: 100%;
  }
  ${when('vertical')(`
    flex-direction: column;
    align-items: start;
  `)};
`



// WEBPACK FOOTER //
// ./src/components/pages/inquiry_form/contents.tsx